<template>
  <div class="row">
    <div class="col-6">
      <idx-card
        :title="$t('menu.settings.hierarchies.titleNewHierarchies')"
        icon="sitemap"
      >
        <div class="form-group">
          <label for="filial"
            >{{ $t('menu.settings.hierarchies.labels.hierarchiesName') }}:
          </label>
          <input
            type="text"
            class="form-control"
            v-model="filial"
            id="filial-ih2"
            :placeholder="$t('menu.settings.hierarchies.placeholderIh2')"
          />
          <div class="invalid-feedback">
            <!-- eslint-disable-next-line prettier/prettier -->
            {{ $t('menu.settings.hierarchies.labels.feedbackInformHierarchiesName') }}
          </div>
        </div>
        <div class="form-group">
          <label for="filial"
            >{{ $t('menu.settings.hierarchies.labels.description') }}:
          </label>
          <input
            type="text"
            class="form-control"
            v-model="description"
            id="description-ih2"
            :placeholder="
              $t('menu.settings.hierarchies.placeholderEnterDescription')
            "
          />
        </div>
        <div v-for="(branch, i) in branches" :key="i">
          <div class="row custom mt-4 mb-4">
            <div class="col-4">
              <input
                type="text"
                class="form-control"
                id="customLabel"
                :placeholder="
                  $t('menu.settings.hierarchies.placeholderCustomField')
                "
              />
            </div>

            <div class="col-8">
              <input
                type="text"
                class="form-control"
                id="customInput"
                :placeholder="$t('menu.settings.hierarchies.placeholderValue')"
              />
            </div>
          </div>
        </div>
        <div class="btn-div">
          <div>
            <button class="btn btn-trash" @click="removeGroup(i)">
              <div class="mask"></div>
              <font-awesome-icon :icon="['fas', 'trash-alt']" />
            </button>
            <button class="btn btn-add ml-1" @click="addGroup">
              <font-awesome-icon :icon="['fas', 'plus']" />
            </button>
          </div>
          <button @click="submitBranch" class="btn btn-primary">
            {{ $t('menu.settings.hierarchies.buttonRegister') }}
          </button>
        </div>
      </idx-card>
    </div>
    <div class="col-6">
      <div class="col-6 p-0 mb-3">
        <div class="search-users">
          <input
            type="text"
            id="filter-filialih2"
            v-model="filterIh2"
            @keyup="handleFilterIh2"
            class="form-control"
            :placeholder="$t('menu.settings.hierarchies.placeholderSearch')"
          />

          <button
            @click="cleanFilterIh2"
            class="btn btn-outline-primary"
            :title="`${'menu.settings.hierarchies.clear'}`"
          >
            {{ $t('menu.settings.hierarchies.clear') }}
          </button>
        </div>
      </div>
      <template>
        <div>
          <b-table
            striped
            hover
            :items="ih2.branches"
            :fields="fields"
            :busy="loading"
          >
            <template v-slot:table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner type="grow" class="align-middle"></b-spinner>
              </div>
            </template>
            <template v-slot:cell(createdAt)="row">
              {{ formatDate(row.item.createdAt) }}
            </template>
            <template v-slot:cell(options)="row">
              <button
                v-b-modal="`edit-branch-${row.item._id}`"
                class="btn btn-outline-primary"
              >
                <font-awesome-icon :icon="['fas', 'pen']" />
              </button>
              <button
                @click="removeBranch(row.item._id)"
                class="btn btn-outline-danger"
              >
                <font-awesome-icon :icon="['fas', 'trash-alt']" />
              </button>
              <modalEditBranch
                :id="row.item._id"
                :description="row.item.description"
                :corporate_name="row.item.corporate_name"
                :secondary_fields="row.item.secondary_fields"
                :type="row.item.type"
                :page="currentPage"
              />
            </template>
          </b-table>
          <div class="pagination-area-ih2">
            <paginate
              v-model="currentPage"
              :pageCount="Math.ceil(ih2.total / 10)"
              :clickHandler="handleBranchesIh2"
              :prevText="'‹'"
              :nextText="'›'"
              :activeClass="'active'"
              :containerClass="'pagination b-pagination'"
              :pageClass="'page-item'"
            >
            </paginate>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Paginate from 'vuejs-paginate';
import swal from 'sweetalert';
import { format } from 'date-fns';
import pt from 'date-fns/locale/pt';
import IdxCard from '@/components/molecules/idx-card';
import modalEditBranch from './modal-edit-branch';

export default {
  name: 'branches',

  data() {
    return {
      filterIh2: null,
      filial: '',
      description: null,
      customField: [],
      branches: [],
      userAuth: null,
      errors: null,
      fields: [],
      currentPage: 1,
      loading: true,
    };
  },

  components: {
    modalEditBranch,
    Paginate,
    IdxCard,
  },

  computed: {
    ...mapFields('branches', ['ih2']),
  },

  methods: {
    ...mapActions('branches', [
      'addBranch',
      'getBranchesIH2',
      'deleteBranch',
      'listBranchesIh2',
    ]),

    async handleBranchesIh2() {
      this.loading = true;
      await this.getBranchesIH2({
        companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
        token: JSON.parse(localStorage.getItem('_indecx')).token,
        page: this.currentPage,
        limit: 10,
        filter: this.filterIh2,
      });
      this.loading = false;
    },

    handleFilterIh2() {
      if (this.filterIh2 !== '' && this.filterIh2 !== null) {
        clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(this.handleBranchesIh2, 600);
      }

      if (this.filterIh2 === '') {
        this.currentPage = 1;
        this.filterIh2 = null;
        this.handleBranchesIh2();
      }
    },

    cleanFilterIh2() {
      this.filterIh2 = null;
      this.handleBranchesIh2();
    },

    formatDate(param) {
      const date = format(new Date(param), 'dd/MM/yyyy', { locale: pt });
      return date;
    },

    async submitBranch() {
      if (this.filial === '') {
        document.getElementById('filial-ih2').classList.add('is-invalid');
      } else {
        document.getElementById('filial-ih2').classList.remove('is-invalid');
      }

      if (this.filial !== '') {
        const custom = document.querySelectorAll('.custom');
        const customInput = document.querySelectorAll('#customInput');
        const customLabel = document.querySelectorAll('#customLabel');

        for (let i = 0; i < custom.length; i += 1) {
          this.customField.push({
            key: customLabel[i].value,
            value: customInput[i].value,
          });
        }

        const newBranch = {
          data: {
            corporate_name: this.filial,
            description: this.description,
            secondary_fields: this.customField,
            type: 'ih2',
          },
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
        };

        try {
          await this.addBranch(newBranch);

          swal(
            this.$t(
              'menu.settings.hierarchies.messages.succesAddHierarchy.title',
            ),
            this.$t(
              'menu.settings.hierarchies.messages.succesAddHierarchy.description',
            ),
            'success',
          );

          await this.getBranchesIH2({
            companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
            token: JSON.parse(localStorage.getItem('_indecx')).token,
          });

          await this.listBranchesIh2({
            companyId: this.userAuth.companyId,
            token: this.userAuth.token,
          });

          this.description = null;
          this.filial = '';
          this.customField = [];
          this.branches.splice(0);
        } catch (error) {
          swal('Oops!', `${error.response.data.message}`, 'warning');
        }
      }
    },

    async addGroup() {
      if (this.branches.length <= 4) {
        await this.branches.push('test');
      }
    },

    async removeGroup() {
      if (this.branches.length > 0) {
        await this.branches.pop('test');
      }
    },

    async removeBranch(branchId) {
      const obj = { branchId, token: this.userAuth.token };

      swal({
        title: this.$t(
          'menu.settings.hierarchies.messages.removeHierarchy.title',
        ),
        text: this.$t(
          'menu.settings.hierarchies.messages.removeHierarchy.description',
        ),
        icon: 'warning',
        buttons: [
          this.$t('menu.settings.hierarchies.buttonCancel'),
          this.$t('menu.settings.hierarchies.buttonRemove'),
        ],
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await this.deleteBranch(obj);

          swal(this.$t('menu.settings.hierarchies.hierarchyRemoved'), {
            icon: 'success',
          });

          await this.getBranchesIH2({
            companyId: JSON.parse(localStorage.getItem('_indecx')).companyId,
            token: JSON.parse(localStorage.getItem('_indecx')).token,
            type: 'ih2',
            limit: 10,
            page: 1,
          });

          await this.listBranchesIh2({
            companyId: this.userAuth.companyId,
            token: this.userAuth.token,
          });
        }
      });
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fields = [
      {
        key: 'corporate_name',
        label: this.$t('menu.settings.hierarchies.labels.corporationName'),
      },
      {
        key: 'createdAt',
        label: this.$t('menu.settings.hierarchies.labels.creationDate'),
      },
      {
        key: 'options',
        label: this.$t('menu.settings.hierarchies.labels.options'),
      },
    ];
  },

  async mounted() {
    this.handleBranchesIh2();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.search-users {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.btn-trash {
  position: relative;
  color: red;
  border: 1px solid red;
  &:hover {
    color: $white;
    background-color: red;
  }
  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
}

.btn-add {
  color: $primary;
  border: 1px solid $primary;
  &:hover {
    color: $white;
    background-color: $primary;
  }
}

.btn-div {
  display: flex;
  justify-content: space-between;
}

.pagination-area-ih2 >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-ih2 .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-ih2 a {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/ih2/index.vue